import { ConditionalGate } from "components/dynamic-content/CondiitonalGate"
import { Condition } from "components/dynamic-content/util/dynamicContent"
import { IAttribute, ICantHave, IHasAny, IMustHave } from "contentful-types"
import React from "react"
import { ReactNode } from "react"

type ContentfulConditionalGateProps = {
  children: ReactNode
  conditions: (ICantHave | IMustHave | IHasAny)[]
}

const ContentfulConditionalGate = ({ children, conditions }: ContentfulConditionalGateProps) => {
  const toCondition = (condition: ICantHave | IMustHave | IHasAny): Condition => {
    const attributes = condition.fields.attributes
      .filter(({ fields }: IAttribute) => fields)
      .map(({ fields: { key } }: IAttribute) => key)
    const conditionType = condition.sys.contentType.sys.id
    return { attributes, conditionType }
  }

  if (conditions) {
    const returnCondition = conditions.map(toCondition)
    return <ConditionalGate conditions={returnCondition}>{children}</ConditionalGate>
  } else {
    return <>{children}</>
  }
}

export { ContentfulConditionalGate }
